/**
 * Atlas welcome — thin mission that owns only the modal shown once per browser.
 * Storage is the existing `WELCOME_TOUR_COMPLETED_KEY` (no new flag).
 */
import type { AtlasMission } from '../atlas.types';

export const welcomeMission: AtlasMission = {
  id: 'welcome',
  title: 'Welcome to Relix Atlas',
  description: "A 30-second intro to what's here and what to try first.",
  kicker: 'Welcome',
  estimatedMinutes: 1,
  entryRoute: '/analytics',
  featureKey: '',
  storage: 'welcome',
  steps: [],
};
